import React from 'react';
import ReactMarkdown from 'react-markdown';
import './PrivacyPolicy.css';
import { privacyContent } from './privacyContent';

const PrivacyPolicy = () => {

    return (
        <>
            <title>Privacy Policy - WizeHelper</title>
            <meta name="description" content="Read our privacy policy to understand how WizeHelper handles and protects your data." />
            <div className="privacy-policy-container">
                <ReactMarkdown>{privacyContent.content}</ReactMarkdown>
            </div>
        </>
    );
};

export default PrivacyPolicy;
